import { useMemo } from 'react';

import { useFishGroupsController_getLineage } from '@/services/hooks';
import type { FishGroupLineageDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import type { UseGetFishGroupLineageResult } from './historyTypes';
import { mapFishGroupLineageToDomain } from './mappers';

export const useGetFishGroupLineage = (
    clientId: number,
    fishGroupId: number,
    options?: DomainQueryOptions<FishGroupLineageDto>
): UseGetFishGroupLineageResult => {
    const query = useFishGroupsController_getLineage(clientId, fishGroupId, options);

    const lineage = useMemo(() => {
        if (!query.data?.data) return null;
        return mapFishGroupLineageToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: lineage,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
